import { constantRouterMap, adminRouterMap, projectRouterMap } from 'router/index'
function hasPermission (roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role))
  } else {
    return true
  }
}
/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter (routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}
const routes = {
  state: {
    projectRoutes: [],
    allRoutes: [],
    adminRoutes: [],
    addRouters: []
  },
  mutations: {
    SET_PROJECTROUTES (state, res) {
      state.projectRoutes = res
    },
    SET_ADMINROUTES (state, res) {
      state.adminRoutes = res
    },
    SET_ALLROUTES (state, res) {
      state.addRouters = res
      state.allRoutes = constantRouterMap.concat(res)
    }
  },
  actions: {
    generateRoutes ({ commit }, data) {
      return new Promise(resolve => {
        const roles = data
        const arrRoles = []
        roles.forEach((item) => {
          console.log(item)
          arrRoles.push(item.roleName)
        })
        console.log(arrRoles)
        let accessedRouters, acessAdminRouters
        if (arrRoles.includes('PI')) {
          accessedRouters = projectRouterMap
          acessAdminRouters = adminRouterMap
        } else {
          accessedRouters = filterAsyncRouter(projectRouterMap, arrRoles)
          acessAdminRouters = filterAsyncRouter(adminRouterMap, arrRoles)
        }
        commit('SET_ALLROUTES', accessedRouters.concat(acessAdminRouters))
        commit('SET_ADMINROUTES', acessAdminRouters)
        commit('SET_PROJECTROUTES', accessedRouters)
        resolve()
      })
    }
  }
}
export default routes



// WEBPACK FOOTER //
// ./src/store/modules/routes.js